var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _ellipse, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _ellipse2, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _ellipse3, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _ellipse4, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _ellipse5, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _ellipse6, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _ellipse7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCoin = function SvgCoin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 120 120",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M120 60c0 33.137-26.863 60-60 60S0 93.137 0 60 26.863 0 60 0s60 26.863 60 60"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M61.73 89.96c11.974-.557 21.413-6.85 21.413-14.531 0-8.048-10.362-14.572-23.143-14.572-11.112 0-20.395 4.931-22.63 11.507-6.396 1.954-10.799 6.046-10.799 10.779 0 6.627 8.635 12 19.286 12 6.582 0 12.394-2.052 15.874-5.183",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBD458",
    d: "M83.143 72.935c0 6.13-9.594 11.1-21.428 11.1s-21.429-4.97-21.429-11.1v-5.392h42.857z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__a)",
    d: "M83.143 72.935c0 6.13-9.594 11.1-21.428 11.1s-21.429-4.97-21.429-11.1v-5.392h42.857z",
    style: {
      mixBlendMode: "color-burn"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__b)",
    d: "M42 77.292v-5.31h.857v6.23a11 11 0 0 1-.857-.92"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__c)",
    d: "M44.571 79.596V74.52h.858v5.63q-.445-.27-.858-.554"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__d)",
    d: "M48 81.464a24 24 0 0 1-.857-.39v-5.285H48z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__e)",
    d: "M50.571 82.418q-.435-.138-.857-.286v-5.075h.857z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__f)",
    d: "M53.143 83.111a34 34 0 0 1-.857-.206v-5.214h.857z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__g)",
    d: "M55.714 83.594q-.432-.066-.857-.14v-5.128h.857z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__h)",
    d: "M58.286 83.893q-.432-.035-.857-.08v-5.487h.857z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__i)",
    d: "M60.857 84.026A42 42 0 0 1 60 84v-5.674h.857z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__j)",
    d: "M63.429 84q-.427.017-.858.026v-5.7h.858z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__k)",
    d: "M66 83.813q-.426.044-.857.08v-5.567H66z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__l)",
    d: "M68.571 83.454q-.424.075-.857.14v-5.268h.857z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__m)",
    d: "M71.143 82.905q-.423.108-.857.206v-5.42h.857z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__n)",
    d: "M73.714 82.132q-.421.148-.857.286v-5.36h.857z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__o)",
    d: "M76.286 81.074a24 24 0 0 1-.857.39v-5.675h.857z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__p)",
    d: "M78 80.15v-5.63h.857v5.076q-.411.284-.857.553"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__q)",
    d: "M80.571 78.211v-6.228h.858v5.31q-.39.47-.858.918"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.715,
    cy: 67.86,
    fill: "#FBD458",
    rx: 21.429,
    ry: 11.1
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.715,
    cy: 67.86,
    fill: "url(#Coin_svg__r)",
    opacity: 0.5,
    rx: 21.429,
    ry: 11.1,
    style: {
      mixBlendMode: "color-burn"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__s)",
    fillRule: "evenodd",
    d: "M43.715 67.85v.01c0 5.08 8.059 9.197 18 9.197s18-4.118 18-9.197v-.02c0-4.87-7.408-8.857-16.78-9.177l.03.022a35.4 35.4 0 0 0-5.704.262l-.025-.018a29 29 0 0 0-4.863 1.047l.02.015c-4.011 1.243-6.997 3.264-8.153 5.654l-.007-.005a5.05 5.05 0 0 0-.518 2.2zm15.934 8.706q1.017.063 2.066.063c4.269 0 8.173-.797 11.174-2.116L52.897 60.347c-4.056 1.245-7.021 3.324-7.987 5.773z",
    clipRule: "evenodd",
    opacity: 0.2,
    style: {
      mixBlendMode: "color-burn"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__t)",
    fillRule: "evenodd",
    d: "M73.956 73.841c3.1-1.584 4.902-3.709 4.902-5.981s-1.802-4.397-4.902-5.981c-3.097-1.583-7.422-2.582-12.241-2.582s-9.144 1-12.241 2.582c-3.1 1.584-4.902 3.709-4.902 5.981s1.801 4.397 4.902 5.981c3.097 1.583 7.422 2.582 12.24 2.582 4.82 0 9.145-1 12.242-2.582m-12.241 3.216c9.941 0 18-4.118 18-9.197 0-5.08-8.059-9.197-18-9.197s-18 4.118-18 9.197c0 5.08 8.059 9.197 18 9.197",
    clipRule: "evenodd",
    opacity: 0.2,
    style: {
      mixBlendMode: "color-burn"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBD458",
    d: "M83.143 66.566c0 6.296-9.594 11.4-21.428 11.4s-21.429-5.104-21.429-11.4V61.03h42.857z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__u)",
    d: "M83.143 66.566c0 6.296-9.594 11.4-21.428 11.4s-21.429-5.104-21.429-11.4V61.03h42.857z",
    style: {
      mixBlendMode: "color-burn"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__v)",
    d: "M42 71.041V65.59h.857v6.397A11 11 0 0 1 42 71.04"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__w)",
    d: "M44.571 73.407v-5.213h.858v5.781a17 17 0 0 1-.858-.568"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__x)",
    d: "M48 75.326q-.438-.195-.857-.401v-5.428H48z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__y)",
    d: "M50.571 76.306a28 28 0 0 1-.857-.294V70.8h.857z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__z)",
    d: "M53.143 77.018a33 33 0 0 1-.857-.212v-5.355h.857z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__A)",
    d: "M55.714 77.513a36 36 0 0 1-.857-.143v-5.267h.857z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__B)",
    d: "M58.286 77.821a39 39 0 0 1-.857-.083v-5.635h.857z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__C)",
    d: "M60.857 77.957A41 41 0 0 1 60 77.93v-5.827h.857z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__D)",
    d: "M63.429 77.93q-.427.018-.858.027v-5.854h.858z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__E)",
    d: "M66 77.738q-.426.045-.857.083v-5.718H66z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__F)",
    d: "M68.571 77.37q-.424.076-.857.143v-5.41h.857z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__G)",
    d: "M71.143 76.806q-.423.11-.857.212V71.45h.857z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__H)",
    d: "M73.714 76.012q-.421.153-.857.294V70.8h.857z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__I)",
    d: "M76.286 74.925q-.42.207-.857.401v-5.829h.857z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__J)",
    d: "M78 73.976v-5.782h.857v5.213q-.411.292-.857.569"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__K)",
    d: "M80.571 71.986v-6.397h.858v5.452q-.39.484-.858.945"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.715,
    cy: 61.354,
    fill: "#FBD458",
    rx: 21.429,
    ry: 11.4
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.715,
    cy: 61.354,
    fill: "url(#Coin_svg__L)",
    opacity: 0.5,
    rx: 21.429,
    ry: 11.4,
    style: {
      mixBlendMode: "color-burn"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__M)",
    fillRule: "evenodd",
    d: "M43.715 61.343v.011c0 5.217 8.059 9.446 18 9.446s18-4.229 18-9.446v-.021c0-5.002-7.408-9.095-16.78-9.424l.03.022a34.5 34.5 0 0 0-5.704.269l-.025-.018a28.5 28.5 0 0 0-4.863 1.075l.02.015c-4.011 1.277-6.997 3.353-8.153 5.808l-.007-.005a5.3 5.3 0 0 0-.518 2.258zm15.934 8.943q1.017.063 2.066.064c4.269 0 8.173-.819 11.174-2.173L52.897 53.638c-4.056 1.28-7.021 3.415-7.987 5.93z",
    clipRule: "evenodd",
    opacity: 0.2,
    style: {
      mixBlendMode: "color-burn"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__N)",
    fillRule: "evenodd",
    d: "M73.956 67.497c3.1-1.627 4.902-3.81 4.902-6.143s-1.802-4.516-4.902-6.143c-3.097-1.625-7.422-2.651-12.241-2.651s-9.144 1.026-12.241 2.651c-3.1 1.627-4.902 3.81-4.902 6.143 0 2.334 1.801 4.516 4.902 6.143 3.097 1.626 7.422 2.652 12.24 2.652 4.82 0 9.145-1.026 12.242-2.652M61.715 70.8c9.941 0 18-4.229 18-9.446s-8.059-9.445-18-9.445-18 4.229-18 9.445 8.059 9.446 18 9.446",
    clipRule: "evenodd",
    opacity: 0.2,
    style: {
      mixBlendMode: "color-burn"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.715,
    cy: 61.286,
    fill: "#454545",
    opacity: 0.3,
    rx: 21.429,
    ry: 11.571,
    style: {
      mixBlendMode: "color-burn"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBD458",
    d: "M85.715 57.995c0 6.296-9.594 11.4-21.429 11.4s-21.429-5.104-21.429-11.4v-5.538h42.858z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__O)",
    d: "M85.715 57.995c0 6.296-9.594 11.4-21.429 11.4s-21.429-5.104-21.429-11.4v-5.538h42.858z",
    style: {
      mixBlendMode: "color-burn"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__P)",
    d: "M44.571 62.47v-5.453h.857v6.397a11 11 0 0 1-.857-.944"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__Q)",
    d: "M47.143 64.836v-5.213H48v5.781a17 17 0 0 1-.857-.568"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__R)",
    d: "M50.571 66.755q-.438-.195-.857-.402v-5.427h.857z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__S)",
    d: "M53.143 67.734a28 28 0 0 1-.857-.293v-5.213h.857z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__T)",
    d: "M55.714 68.446a34 34 0 0 1-.857-.211V62.88h.857z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__U)",
    d: "M58.286 68.942a36 36 0 0 1-.858-.143V63.53h.858z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__V)",
    d: "M60.857 69.25a38 38 0 0 1-.857-.083V63.53h.857z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__W)",
    d: "M63.428 69.386a41 41 0 0 1-.857-.027V63.53h.857z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__X)",
    d: "M66 69.359q-.426.017-.857.027V63.53H66z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__Y)",
    d: "M68.571 69.167q-.426.046-.857.082v-5.718h.857z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__Z)",
    d: "M71.143 68.799q-.425.075-.857.143v-5.41h.857z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aa)",
    d: "M73.714 68.235q-.423.11-.857.211V62.88h.857z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__ab)",
    d: "M76.286 67.44q-.422.153-.858.294V62.23h.858z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__ac)",
    d: "M78.857 66.353q-.419.207-.857.401v-5.828h.857z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__ad)",
    d: "M80.571 65.404v-5.781h.857v5.213q-.411.291-.857.568"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__ae)",
    d: "M83.143 63.414v-6.397H84v5.453q-.39.484-.857.944"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.286,
    cy: 52.783,
    fill: "#FBD458",
    rx: 21.429,
    ry: 11.4
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.286,
    cy: 52.783,
    fill: "url(#Coin_svg__af)",
    opacity: 0.5,
    rx: 21.429,
    ry: 11.4,
    style: {
      mixBlendMode: "color-burn"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__ag)",
    fillRule: "evenodd",
    d: "M46.286 52.772v.01c0 5.218 8.059 9.447 18 9.447s18-4.23 18-9.446v-.021c0-5.002-7.408-9.096-16.78-9.425l.031.022q-.62-.022-1.25-.022c-1.538 0-3.03.101-4.455.292l-.025-.018a28.5 28.5 0 0 0-4.863 1.075l.02.015c-4.011 1.277-6.996 3.353-8.153 5.807l-.007-.005a5.3 5.3 0 0 0-.518 2.258zm15.935 8.942a33 33 0 0 0 2.065.065c4.27 0 8.174-.819 11.174-2.174L55.468 45.067c-4.056 1.279-7.02 3.414-7.987 5.929z",
    clipRule: "evenodd",
    opacity: 0.2,
    style: {
      mixBlendMode: "color-burn"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__ah)",
    fillRule: "evenodd",
    d: "M76.527 58.926c3.1-1.627 4.902-3.81 4.902-6.143 0-2.334-1.802-4.516-4.902-6.143-3.097-1.625-7.422-2.651-12.24-2.651-4.82 0-9.145 1.026-12.242 2.65-3.1 1.628-4.902 3.81-4.902 6.144s1.802 4.516 4.902 6.143c3.097 1.625 7.422 2.651 12.241 2.651s9.144-1.026 12.241-2.651m-12.24 3.303c9.94 0 18-4.23 18-9.446 0-5.217-8.06-9.446-18-9.446-9.942 0-18 4.23-18 9.446 0 5.217 8.058 9.446 18 9.446",
    clipRule: "evenodd",
    opacity: 0.2,
    style: {
      mixBlendMode: "color-burn"
    }
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBD458",
    d: "M85.715 51.506c0 6.13-9.594 11.1-21.429 11.1s-21.429-4.97-21.429-11.1v-5.392h42.858z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__ai)",
    d: "M85.715 51.506c0 6.13-9.594 11.1-21.429 11.1s-21.429-4.97-21.429-11.1v-5.392h42.858z",
    style: {
      mixBlendMode: "color-burn"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aj)",
    d: "M44.571 55.864v-5.31h.857v6.229a11 11 0 0 1-.857-.92"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__ak)",
    d: "M47.143 58.167v-5.076H48v5.63q-.446-.27-.857-.554"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__al)",
    d: "M50.571 60.035a24 24 0 0 1-.857-.39V54.36h.857z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__am)",
    d: "M53.143 60.99q-.435-.139-.857-.286v-5.075h.857z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__an)",
    d: "M55.714 61.682a34 34 0 0 1-.857-.205v-5.214h.857z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__ao)",
    d: "M58.286 62.165q-.433-.065-.858-.14v-5.128h.858z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__ap)",
    d: "M60.857 62.465q-.431-.036-.857-.08v-5.488h.857z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aq)",
    d: "M63.428 62.598a42 42 0 0 1-.857-.027v-5.674h.857z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__ar)",
    d: "M66 62.571q-.426.017-.857.026v-5.7H66z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__as)",
    d: "M68.571 62.384q-.426.045-.857.08v-5.567h.857z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__at)",
    d: "M71.143 62.026q-.425.074-.857.14v-5.269h.857z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__au)",
    d: "M73.714 61.477q-.423.107-.857.205v-5.42h.857z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__av)",
    d: "M76.286 60.704q-.422.148-.858.285v-5.36h.858z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aw)",
    d: "M78.857 59.645a24 24 0 0 1-.857.39V54.36h.857z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__ax)",
    d: "M80.571 58.72v-5.629h.857v5.076q-.411.285-.857.553"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__ay)",
    d: "M83.143 56.783v-6.229H84v5.31q-.39.47-.857.919"
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.286,
    cy: 46.431,
    fill: "#FBD458",
    rx: 21.429,
    ry: 11.1
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.286,
    cy: 46.431,
    fill: "url(#Coin_svg__az)",
    opacity: 0.5,
    rx: 21.429,
    ry: 11.1,
    style: {
      mixBlendMode: "color-burn"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aA)",
    fillRule: "evenodd",
    d: "M46.286 46.42v.011c0 5.08 8.059 9.198 18 9.198s18-4.118 18-9.198v-.02c0-4.87-7.408-8.856-16.78-9.177l.031.022q-.62-.022-1.25-.022c-1.538 0-3.03.099-4.455.284l-.025-.017a29 29 0 0 0-4.863 1.047l.02.014c-4.011 1.243-6.996 3.265-8.153 5.655l-.007-.005a5.05 5.05 0 0 0-.518 2.199zm15.935 8.708q1.016.062 2.065.063c4.27 0 8.174-.798 11.174-2.117L55.468 38.918c-4.056 1.246-7.02 3.325-7.987 5.773z",
    clipRule: "evenodd",
    opacity: 0.2,
    style: {
      mixBlendMode: "color-burn"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aB)",
    fillRule: "evenodd",
    d: "M76.527 52.413c3.1-1.584 4.902-3.71 4.902-5.982 0-2.271-1.802-4.397-4.902-5.981-3.097-1.582-7.422-2.581-12.24-2.581-4.82 0-9.145.999-12.242 2.581-3.1 1.584-4.902 3.71-4.902 5.981s1.802 4.398 4.902 5.982c3.097 1.582 7.422 2.581 12.241 2.581s9.144-.999 12.241-2.581m-12.24 3.216c9.94 0 18-4.118 18-9.198 0-5.079-8.06-9.197-18-9.197-9.942 0-18 4.118-18 9.197 0 5.08 8.058 9.198 18 9.198",
    clipRule: "evenodd",
    opacity: 0.2,
    style: {
      mixBlendMode: "color-burn"
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBD458",
    d: "M85.715 46.852c0 6.296-9.594 11.4-21.429 11.4s-21.429-5.104-21.429-11.4v-5.538h42.858z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aC)",
    d: "M85.715 46.852c0 6.296-9.594 11.4-21.429 11.4s-21.429-5.104-21.429-11.4v-5.538h42.858z",
    style: {
      mixBlendMode: "color-burn"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aD)",
    d: "M44.571 51.327v-5.453h.857v6.397a11 11 0 0 1-.857-.944"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aE)",
    d: "M47.143 53.693V48.48H48v5.781a17 17 0 0 1-.857-.568"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aF)",
    d: "M50.571 55.612q-.438-.195-.857-.401v-5.428h.857z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aG)",
    d: "M53.143 56.591q-.435-.141-.857-.293v-5.212h.857z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aH)",
    d: "M55.714 57.303a33 33 0 0 1-.857-.211v-5.355h.857z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aI)",
    d: "M58.286 57.799a36 36 0 0 1-.858-.143v-5.267h.858z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aJ)",
    d: "M60.857 58.107a39 39 0 0 1-.857-.083v-5.635h.857z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aK)",
    d: "M63.428 58.243a41 41 0 0 1-.857-.027v-5.827h.857z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aL)",
    d: "M66 58.216q-.426.017-.857.027v-5.854H66z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aM)",
    d: "M68.571 58.024q-.426.045-.857.083v-5.718h.857z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aN)",
    d: "M71.143 57.656q-.425.075-.857.143v-5.41h.857z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aO)",
    d: "M73.714 57.092q-.423.11-.857.211v-5.566h.857z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aP)",
    d: "M76.286 56.298q-.422.152-.858.293v-5.505h.858z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aQ)",
    d: "M78.857 55.21q-.419.207-.857.402v-5.83h.857z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aR)",
    d: "M80.571 54.261V48.48h.857v5.213q-.411.291-.857.568"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aS)",
    d: "M83.143 52.271v-6.397H84v5.453q-.39.485-.857.944"
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.286,
    cy: 41.64,
    fill: "#FBD458",
    rx: 21.429,
    ry: 11.4
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.286,
    cy: 41.64,
    fill: "url(#Coin_svg__aT)",
    opacity: 0.5,
    rx: 21.429,
    ry: 11.4,
    style: {
      mixBlendMode: "color-burn"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aU)",
    fillRule: "evenodd",
    d: "M46.286 41.629v.011c0 5.217 8.059 9.446 18 9.446s18-4.23 18-9.446v-.021c0-5.002-7.408-9.096-16.78-9.425l.031.023a34.5 34.5 0 0 0-5.705.269l-.025-.018a28.5 28.5 0 0 0-4.863 1.075l.02.015c-4.011 1.277-6.996 3.353-8.153 5.808l-.007-.006a5.3 5.3 0 0 0-.518 2.259zm15.935 8.942q1.016.065 2.065.065c4.27 0 8.174-.819 11.174-2.174L55.468 33.924c-4.056 1.28-7.02 3.414-7.987 5.929z",
    clipRule: "evenodd",
    opacity: 0.2,
    style: {
      mixBlendMode: "color-burn"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aV)",
    fillRule: "evenodd",
    d: "M76.527 47.783c3.1-1.627 4.902-3.81 4.902-6.143s-1.802-4.516-4.902-6.143c-3.097-1.625-7.422-2.651-12.24-2.651-4.82 0-9.145 1.026-12.242 2.65-3.1 1.628-4.902 3.81-4.902 6.144s1.802 4.516 4.902 6.143c3.097 1.625 7.422 2.651 12.241 2.651s9.144-1.026 12.241-2.65m-12.24 3.303c9.94 0 18-4.23 18-9.446 0-5.217-8.06-9.446-18-9.446-9.942 0-18 4.23-18 9.446 0 5.217 8.058 9.446 18 9.446",
    clipRule: "evenodd",
    opacity: 0.2,
    style: {
      mixBlendMode: "color-burn"
    }
  }), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBD458",
    d: "M83.143 40.852c0 6.296-9.594 11.4-21.428 11.4s-21.429-5.104-21.429-11.4v-5.538h42.857z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aW)",
    d: "M83.143 40.852c0 6.296-9.594 11.4-21.428 11.4s-21.429-5.104-21.429-11.4v-5.538h42.857z",
    style: {
      mixBlendMode: "color-burn"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aX)",
    d: "M42 45.327v-5.453h.857v6.397a11 11 0 0 1-.857-.944"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aY)",
    d: "M44.571 47.693V42.48h.858v5.781a17 17 0 0 1-.858-.568"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__aZ)",
    d: "M48 49.612q-.438-.195-.857-.401v-5.428H48z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__ba)",
    d: "M50.571 50.591q-.435-.141-.857-.293v-5.212h.857z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bb)",
    d: "M53.143 51.303a33 33 0 0 1-.857-.211v-5.355h.857z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bc)",
    d: "M55.714 51.799a36 36 0 0 1-.857-.143v-5.267h.857z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bd)",
    d: "M58.286 52.107a39 39 0 0 1-.857-.083v-5.635h.857z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__be)",
    d: "M60.857 52.243a41 41 0 0 1-.857-.027v-5.827h.857z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bf)",
    d: "M63.429 52.216q-.427.017-.858.027v-5.854h.858z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bg)",
    d: "M66 52.024q-.426.045-.857.083v-5.718H66z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bh)",
    d: "M68.571 51.656q-.424.075-.857.143v-5.41h.857z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bi)",
    d: "M71.143 51.092q-.423.11-.857.211v-5.566h.857z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bj)",
    d: "M73.714 50.298q-.421.152-.857.293v-5.505h.857z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bk)",
    d: "M76.286 49.21q-.42.207-.857.402v-5.83h.857z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bl)",
    d: "M78 48.261V42.48h.857v5.213q-.411.291-.857.568"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bm)",
    d: "M80.571 46.271v-6.397h.858v5.453q-.39.485-.858.944"
  }))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.715,
    cy: 35.64,
    fill: "#FBD458",
    rx: 21.429,
    ry: 11.4
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.715,
    cy: 35.64,
    fill: "url(#Coin_svg__bn)",
    opacity: 0.5,
    rx: 21.429,
    ry: 11.4,
    style: {
      mixBlendMode: "color-burn"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bo)",
    fillRule: "evenodd",
    d: "M43.715 35.629v.011c0 5.217 8.059 9.446 18 9.446s18-4.23 18-9.446v-.021c0-5.002-7.408-9.096-16.78-9.425l.03.023a34.5 34.5 0 0 0-5.704.269l-.025-.018a28.5 28.5 0 0 0-4.863 1.075l.02.015c-4.011 1.277-6.997 3.353-8.153 5.808l-.007-.006a5.3 5.3 0 0 0-.518 2.259zm15.934 8.942q1.017.065 2.066.065c4.269 0 8.173-.819 11.174-2.174L52.897 27.924c-4.056 1.28-7.021 3.414-7.987 5.929z",
    clipRule: "evenodd",
    opacity: 0.2,
    style: {
      mixBlendMode: "color-burn"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bp)",
    fillRule: "evenodd",
    d: "M73.956 41.783c3.1-1.627 4.902-3.81 4.902-6.143s-1.802-4.516-4.902-6.143c-3.097-1.625-7.422-2.651-12.241-2.651s-9.144 1.026-12.241 2.65c-3.1 1.628-4.902 3.81-4.902 6.144s1.801 4.516 4.902 6.143c3.097 1.625 7.422 2.651 12.24 2.651 4.82 0 9.145-1.026 12.242-2.65m-12.241 3.303c9.941 0 18-4.23 18-9.446 0-5.217-8.059-9.446-18-9.446s-18 4.23-18 9.446c0 5.217 8.059 9.446 18 9.446",
    clipRule: "evenodd",
    opacity: 0.2,
    style: {
      mixBlendMode: "color-burn"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M66.429 62.571 48 52.714l3.857 30c3.429 1.372 11 1.429 12.857 1.286v-4.286l2.572-2.143-2.143.223v-4.937L69.429 69l-3.858.429v-5.143l2.143-1.715z",
    opacity: 0.3,
    style: {
      mixBlendMode: "color-burn"
    }
  }), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBD458",
    d: "M35.79 93.574c8.068 1.883 16.788-5.934 19.478-17.459s-1.67-22.394-9.737-24.277l-7.096-1.656-9.74 41.736z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bq)",
    d: "M35.79 93.574c8.068 1.883 16.788-5.934 19.478-17.459s-1.67-22.394-9.737-24.277l-7.096-1.656-9.74 41.736z",
    style: {
      mixBlendMode: "color-burn"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__br)",
    d: "m50.876 54.846-6.987-1.63-.195.834 8.197 1.913q-.483-.593-1.015-1.117"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bs)",
    d: "m53.323 58.058-6.68-1.56-.195.835 7.408 1.73a18 18 0 0 0-.533-1.005"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bt)",
    d: "M55.002 61.97q-.15-.484-.32-.954l-6.954-1.623-.195.834z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bu)",
    d: "M55.673 64.768q-.082-.467-.181-.923l-6.68-1.559-.194.835z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bv)",
    d: "M56 67.485q-.03-.453-.075-.898l-6.862-1.602-.195.835z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bw)",
    d: "M56.051 70.137q.012-.441.011-.878l-6.749-1.575-.194.835z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bx)",
    d: "M55.861 72.733q.051-.431.089-.86l-7.221-1.685-.195.835z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__by)",
    d: "M55.451 75.278q.087-.422.16-.843l-7.466-1.743-.195.835z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bz)",
    d: "M54.832 77.774q.12-.41.23-.827l-7.502-1.75-.195.834z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bA)",
    d: "M54.002 80.22q.155-.399.3-.81l-7.326-1.71-.195.835z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bB)",
    d: "M52.945 82.615q.195-.39.379-.792l-6.933-1.618-.195.835z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bC)",
    d: "M51.638 84.95q.238-.38.466-.771l-7.132-1.665-.195.835z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bD)",
    d: "M50.037 87.217q.291-.365.57-.747l-7.054-1.647-.195.835z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bE)",
    d: "M48.059 89.396q.36-.346.709-.715l-7.47-1.743-.194.835z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bF)",
    d: "m46.453 90.781-7.408-1.729-.195.835 6.68 1.56q.467-.315.923-.666"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bG)",
    d: "m43.318 92.69-8.196-1.913-.195.835 6.987 1.63q.708-.233 1.404-.552"
  }))), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.429,
    cy: 15,
    fill: "#FBD458",
    rx: 21.429,
    ry: 15,
    transform: "scale(-1 1)rotate(76.862 -41.657 8.157)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.429,
    cy: 15,
    fill: "url(#Coin_svg__bH)",
    opacity: 0.5,
    rx: 21.429,
    ry: 15,
    style: {
      mixBlendMode: "color-burn"
    },
    transform: "scale(-1 1)rotate(76.862 -41.657 8.157)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bI)",
    fillRule: "evenodd",
    d: "m38.06 53.615.014.003c6.684 1.56 10.271 10.673 8.012 20.354s-9.51 16.264-16.195 14.704l-.014-.003-.013-.003c-6.409-1.496-9.97-9.934-8.262-19.16l.022.037q.113-.61.255-1.225a26 26 0 0 1 1.386-4.25l-.017-.03a23 23 0 0 1 2.483-4.414l.014.025c2.548-3.525 5.887-5.811 9.295-6.203l-.005-.01a8.8 8.8 0 0 1 3.012.172zm7.836 18.192q-.149 1.009-.386 2.03c-.97 4.158-2.907 7.715-5.325 10.232L26.1 60.252c2.561-3.567 5.97-5.815 9.412-6.004z",
    clipRule: "evenodd",
    opacity: 0.2,
    style: {
      mixBlendMode: "color-burn"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Coin_svg__bJ)",
    fillRule: "evenodd",
    d: "M39.07 84.905c-2.789 2.533-5.995 3.634-8.985 2.936-2.99-.697-5.377-3.104-6.757-6.61-1.378-3.502-1.71-8.021-.615-12.714s3.393-8.598 6.18-11.127c2.79-2.533 5.995-3.635 8.985-2.937s5.377 3.105 6.757 6.61c1.379 3.503 1.71 8.022.615 12.714s-3.393 8.598-6.18 11.128m7.015-10.933c-2.26 9.681-9.51 16.264-16.195 14.704-6.684-1.56-10.271-10.673-8.012-20.354s9.51-16.264 16.195-14.704 10.272 10.673 8.012 20.354",
    clipRule: "evenodd",
    opacity: 0.2,
    style: {
      mixBlendMode: "color-burn"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__a",
    x1: 80.143,
    x2: 37.554,
    y1: 84.035,
    y2: 64.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#595959",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7C7C",
    stopOpacity: 0.87
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__b",
    x1: 138.429,
    x2: 72.566,
    y1: 42.806,
    y2: 107.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__c",
    x1: 138.429,
    x2: 72.566,
    y1: 42.806,
    y2: 107.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__d",
    x1: 138.429,
    x2: 72.566,
    y1: 42.806,
    y2: 107.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__e",
    x1: 138.429,
    x2: 72.566,
    y1: 42.806,
    y2: 107.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__f",
    x1: 138.429,
    x2: 72.566,
    y1: 42.806,
    y2: 107.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__g",
    x1: 138.429,
    x2: 72.566,
    y1: 42.806,
    y2: 107.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__h",
    x1: 138.429,
    x2: 72.566,
    y1: 42.806,
    y2: 107.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__i",
    x1: 138.429,
    x2: 72.566,
    y1: 42.806,
    y2: 107.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__j",
    x1: 138.429,
    x2: 72.566,
    y1: 42.806,
    y2: 107.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__k",
    x1: 138.429,
    x2: 72.566,
    y1: 42.806,
    y2: 107.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__l",
    x1: 138.429,
    x2: 72.566,
    y1: 42.806,
    y2: 107.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__m",
    x1: 138.429,
    x2: 72.566,
    y1: 42.806,
    y2: 107.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__n",
    x1: 138.429,
    x2: 72.566,
    y1: 42.806,
    y2: 107.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__o",
    x1: 138.429,
    x2: 72.566,
    y1: 42.806,
    y2: 107.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__p",
    x1: 138.429,
    x2: 72.566,
    y1: 42.806,
    y2: 107.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__q",
    x1: 138.429,
    x2: 72.566,
    y1: 42.806,
    y2: 107.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__r",
    x1: 88.286,
    x2: 72.656,
    y1: 88.062,
    y2: 47.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__s",
    x1: 75.429,
    x2: 51.438,
    y1: 75.471,
    y2: 59.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#848484",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__t",
    x1: 67.715,
    x2: 58.777,
    y1: 59.931,
    y2: 78.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C5C5C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__u",
    x1: 80.143,
    x2: 37.16,
    y1: 77.966,
    y2: 58.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#595959",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7C7C",
    stopOpacity: 0.87
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__v",
    x1: 138.429,
    x2: 70.829,
    y1: 35.623,
    y2: 100.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__w",
    x1: 138.429,
    x2: 70.829,
    y1: 35.623,
    y2: 100.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__x",
    x1: 138.429,
    x2: 70.829,
    y1: 35.623,
    y2: 100.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__y",
    x1: 138.429,
    x2: 70.829,
    y1: 35.623,
    y2: 100.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__z",
    x1: 138.429,
    x2: 70.829,
    y1: 35.623,
    y2: 100.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__A",
    x1: 138.429,
    x2: 70.829,
    y1: 35.623,
    y2: 100.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__B",
    x1: 138.429,
    x2: 70.829,
    y1: 35.623,
    y2: 100.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__C",
    x1: 138.429,
    x2: 70.829,
    y1: 35.623,
    y2: 100.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__D",
    x1: 138.429,
    x2: 70.829,
    y1: 35.623,
    y2: 100.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__E",
    x1: 138.429,
    x2: 70.829,
    y1: 35.623,
    y2: 100.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__F",
    x1: 138.429,
    x2: 70.829,
    y1: 35.623,
    y2: 100.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__G",
    x1: 138.429,
    x2: 70.829,
    y1: 35.623,
    y2: 100.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__H",
    x1: 138.429,
    x2: 70.829,
    y1: 35.623,
    y2: 100.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__I",
    x1: 138.429,
    x2: 70.829,
    y1: 35.623,
    y2: 100.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__J",
    x1: 138.429,
    x2: 70.829,
    y1: 35.623,
    y2: 100.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__K",
    x1: 138.429,
    x2: 70.829,
    y1: 35.623,
    y2: 100.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__L",
    x1: 88.286,
    x2: 71.918,
    y1: 82.102,
    y2: 41.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__M",
    x1: 75.429,
    x2: 51.05,
    y1: 69.171,
    y2: 53.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#848484",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__N",
    x1: 67.715,
    x2: 58.383,
    y1: 53.211,
    y2: 72.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C5C5C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__O",
    x1: 82.715,
    x2: 39.731,
    y1: 69.395,
    y2: 50.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#595959",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7C7C",
    stopOpacity: 0.87
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__P",
    x1: 141,
    x2: 73.4,
    y1: 27.051,
    y2: 92.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__Q",
    x1: 141,
    x2: 73.4,
    y1: 27.051,
    y2: 92.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__R",
    x1: 141,
    x2: 73.4,
    y1: 27.051,
    y2: 92.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__S",
    x1: 141,
    x2: 73.4,
    y1: 27.051,
    y2: 92.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__T",
    x1: 141,
    x2: 73.4,
    y1: 27.051,
    y2: 92.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__U",
    x1: 141,
    x2: 73.4,
    y1: 27.051,
    y2: 92.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__V",
    x1: 141,
    x2: 73.4,
    y1: 27.051,
    y2: 92.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__W",
    x1: 141,
    x2: 73.4,
    y1: 27.051,
    y2: 92.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__X",
    x1: 141,
    x2: 73.4,
    y1: 27.051,
    y2: 92.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__Y",
    x1: 141,
    x2: 73.4,
    y1: 27.051,
    y2: 92.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__Z",
    x1: 141,
    x2: 73.4,
    y1: 27.051,
    y2: 92.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aa",
    x1: 141,
    x2: 73.4,
    y1: 27.051,
    y2: 92.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__ab",
    x1: 141,
    x2: 73.4,
    y1: 27.051,
    y2: 92.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__ac",
    x1: 141,
    x2: 73.4,
    y1: 27.051,
    y2: 92.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__ad",
    x1: 141,
    x2: 73.4,
    y1: 27.051,
    y2: 92.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__ae",
    x1: 141,
    x2: 73.4,
    y1: 27.051,
    y2: 92.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__af",
    x1: 90.857,
    x2: 74.49,
    y1: 73.531,
    y2: 32.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__ag",
    x1: 78,
    x2: 53.621,
    y1: 60.6,
    y2: 44.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#848484",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__ah",
    x1: 70.286,
    x2: 60.954,
    y1: 44.64,
    y2: 63.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C5C5C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__ai",
    x1: 82.715,
    x2: 40.125,
    y1: 62.606,
    y2: 42.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#595959",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7C7C",
    stopOpacity: 0.87
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aj",
    x1: 141,
    x2: 75.137,
    y1: 21.377,
    y2: 86.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__ak",
    x1: 141,
    x2: 75.137,
    y1: 21.377,
    y2: 86.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__al",
    x1: 141,
    x2: 75.137,
    y1: 21.377,
    y2: 86.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__am",
    x1: 141,
    x2: 75.137,
    y1: 21.377,
    y2: 86.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__an",
    x1: 141,
    x2: 75.137,
    y1: 21.377,
    y2: 86.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__ao",
    x1: 141,
    x2: 75.137,
    y1: 21.377,
    y2: 86.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__ap",
    x1: 141,
    x2: 75.137,
    y1: 21.377,
    y2: 86.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aq",
    x1: 141,
    x2: 75.137,
    y1: 21.377,
    y2: 86.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__ar",
    x1: 141,
    x2: 75.137,
    y1: 21.377,
    y2: 86.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__as",
    x1: 141,
    x2: 75.137,
    y1: 21.377,
    y2: 86.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__at",
    x1: 141,
    x2: 75.137,
    y1: 21.377,
    y2: 86.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__au",
    x1: 141,
    x2: 75.137,
    y1: 21.377,
    y2: 86.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__av",
    x1: 141,
    x2: 75.137,
    y1: 21.377,
    y2: 86.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aw",
    x1: 141,
    x2: 75.137,
    y1: 21.377,
    y2: 86.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__ax",
    x1: 141,
    x2: 75.137,
    y1: 21.377,
    y2: 86.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__ay",
    x1: 141,
    x2: 75.137,
    y1: 21.377,
    y2: 86.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__az",
    x1: 90.857,
    x2: 75.228,
    y1: 66.633,
    y2: 26.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aA",
    x1: 78,
    x2: 54.01,
    y1: 54.043,
    y2: 38.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#848484",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aB",
    x1: 70.286,
    x2: 61.348,
    y1: 38.503,
    y2: 57.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C5C5C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aC",
    x1: 82.715,
    x2: 39.731,
    y1: 58.252,
    y2: 38.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#595959",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7C7C",
    stopOpacity: 0.87
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aD",
    x1: 141,
    x2: 73.4,
    y1: 15.909,
    y2: 81.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aE",
    x1: 141,
    x2: 73.4,
    y1: 15.909,
    y2: 81.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aF",
    x1: 141,
    x2: 73.4,
    y1: 15.909,
    y2: 81.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aG",
    x1: 141,
    x2: 73.4,
    y1: 15.909,
    y2: 81.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aH",
    x1: 141,
    x2: 73.4,
    y1: 15.909,
    y2: 81.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aI",
    x1: 141,
    x2: 73.4,
    y1: 15.909,
    y2: 81.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aJ",
    x1: 141,
    x2: 73.4,
    y1: 15.909,
    y2: 81.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aK",
    x1: 141,
    x2: 73.4,
    y1: 15.909,
    y2: 81.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aL",
    x1: 141,
    x2: 73.4,
    y1: 15.909,
    y2: 81.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aM",
    x1: 141,
    x2: 73.4,
    y1: 15.909,
    y2: 81.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aN",
    x1: 141,
    x2: 73.4,
    y1: 15.909,
    y2: 81.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aO",
    x1: 141,
    x2: 73.4,
    y1: 15.909,
    y2: 81.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aP",
    x1: 141,
    x2: 73.4,
    y1: 15.909,
    y2: 81.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aQ",
    x1: 141,
    x2: 73.4,
    y1: 15.909,
    y2: 81.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aR",
    x1: 141,
    x2: 73.4,
    y1: 15.909,
    y2: 81.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aS",
    x1: 141,
    x2: 73.4,
    y1: 15.909,
    y2: 81.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aT",
    x1: 90.857,
    x2: 74.49,
    y1: 62.388,
    y2: 21.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aU",
    x1: 78,
    x2: 53.621,
    y1: 49.457,
    y2: 33.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#848484",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aV",
    x1: 70.286,
    x2: 60.954,
    y1: 33.497,
    y2: 52.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C5C5C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aW",
    x1: 80.143,
    x2: 37.16,
    y1: 52.252,
    y2: 32.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#595959",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7C7C",
    stopOpacity: 0.87
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aX",
    x1: 138.429,
    x2: 70.829,
    y1: 9.909,
    y2: 75.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aY",
    x1: 138.429,
    x2: 70.829,
    y1: 9.909,
    y2: 75.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__aZ",
    x1: 138.429,
    x2: 70.829,
    y1: 9.909,
    y2: 75.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__ba",
    x1: 138.429,
    x2: 70.829,
    y1: 9.909,
    y2: 75.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bb",
    x1: 138.429,
    x2: 70.829,
    y1: 9.909,
    y2: 75.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bc",
    x1: 138.429,
    x2: 70.829,
    y1: 9.909,
    y2: 75.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bd",
    x1: 138.429,
    x2: 70.829,
    y1: 9.909,
    y2: 75.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__be",
    x1: 138.429,
    x2: 70.829,
    y1: 9.909,
    y2: 75.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bf",
    x1: 138.429,
    x2: 70.829,
    y1: 9.909,
    y2: 75.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bg",
    x1: 138.429,
    x2: 70.829,
    y1: 9.909,
    y2: 75.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bh",
    x1: 138.429,
    x2: 70.829,
    y1: 9.909,
    y2: 75.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bi",
    x1: 138.429,
    x2: 70.829,
    y1: 9.909,
    y2: 75.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bj",
    x1: 138.429,
    x2: 70.829,
    y1: 9.909,
    y2: 75.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bk",
    x1: 138.429,
    x2: 70.829,
    y1: 9.909,
    y2: 75.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bl",
    x1: 138.429,
    x2: 70.829,
    y1: 9.909,
    y2: 75.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bm",
    x1: 138.429,
    x2: 70.829,
    y1: 9.909,
    y2: 75.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bn",
    x1: 88.286,
    x2: 71.918,
    y1: 56.388,
    y2: 15.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bo",
    x1: 75.429,
    x2: 51.05,
    y1: 43.457,
    y2: 27.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#848484",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bp",
    x1: 67.715,
    x2: 58.383,
    y1: 27.497,
    y2: 46.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C5C5C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bq",
    x1: 51.079,
    x2: 46.157,
    y1: 94.062,
    y2: 45.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#595959",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C7C7C",
    stopOpacity: 0.87
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__br",
    x1: -16.425,
    x2: 63.378,
    y1: 138.158,
    y2: 69.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bs",
    x1: -16.425,
    x2: 63.378,
    y1: 138.158,
    y2: 69.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bt",
    x1: -16.425,
    x2: 63.378,
    y1: 138.158,
    y2: 69.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bu",
    x1: -16.425,
    x2: 63.378,
    y1: 138.158,
    y2: 69.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bv",
    x1: -16.425,
    x2: 63.378,
    y1: 138.158,
    y2: 69.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bw",
    x1: -16.425,
    x2: 63.378,
    y1: 138.158,
    y2: 69.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bx",
    x1: -16.425,
    x2: 63.378,
    y1: 138.158,
    y2: 69.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__by",
    x1: -16.425,
    x2: 63.378,
    y1: 138.158,
    y2: 69.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bz",
    x1: -16.425,
    x2: 63.378,
    y1: 138.158,
    y2: 69.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bA",
    x1: -16.425,
    x2: 63.378,
    y1: 138.158,
    y2: 69.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bB",
    x1: -16.425,
    x2: 63.378,
    y1: 138.158,
    y2: 69.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bC",
    x1: -16.425,
    x2: 63.378,
    y1: 138.158,
    y2: 69.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bD",
    x1: -16.425,
    x2: 63.378,
    y1: 138.158,
    y2: 69.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bE",
    x1: -16.425,
    x2: 63.378,
    y1: 138.158,
    y2: 69.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bF",
    x1: -16.425,
    x2: 63.378,
    y1: 138.158,
    y2: 69.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bG",
    x1: -16.425,
    x2: 63.378,
    y1: 138.158,
    y2: 69.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bH",
    x1: 48,
    x2: 22.259,
    y1: 42.3,
    y2: -6.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bI",
    x1: 40.882,
    x2: 33.858,
    y1: 86.841,
    y2: 56.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#848484",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Coin_svg__bJ",
    x1: 22.184,
    x2: 46.684,
    y1: 74.555,
    y2: 65.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C5C5C",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCoin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "7f361c3303343040a9ae69b46e312776.svg";